import { Component, Input } from "@angular/core";

@Component({
  selector: "app-icon-pause",
  imports: [],
  templateUrl: "./icon-pause.component.html",
  styleUrl: "./icon-pause.component.scss",
})
export class IconPauseComponent {
  @Input() color = "#000";
  @Input() customClass: string;
}
